const DISMISSED_KEY = 'kinola-calendar-week-start-notice-dismissed';

/**
 * One-off announcement on the calendar page about the configurable week start. The markup is
 * rendered hidden so nothing flashes before the dismissal state is known; it is revealed here
 * unless this browser has already dismissed it. Temporary: remove once the feature is old news.
 */
export const initCalendarNotice = (): void => {
    const notice = $('.js-calendar-notice');
    if (!notice.length || localStorage.getItem(DISMISSED_KEY)) {
        return;
    }

    notice.prop('hidden', false);
    notice.find('.js-calendar-notice-dismiss').on('click', (): void => {
        localStorage.setItem(DISMISSED_KEY, '1');
        notice.remove();
    });
};
